import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { makeStyles } from '@material-ui/styles';
import classNames from 'classnames';
import { CustomTypography } from '~/modules/common/components/ListTable/renderers';
import { PROBLEM_FILTER_OPTIONS } from '../../ProblemFilterDropdown';
import { FormattedUnitValue } from '../columnRenders';

const useStyles = makeStyles(theme => ({
  benchOverallocationValue: {
    color: theme.palette.error.main
  },
  totalLabel: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body2.fontSize,
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.caption.fontSize
    }
  }
}));

const useListTableFooterColumns = ({
  totals,
  selectedProblem,
  overviewUnit
}) => {
  const classes = useStyles();

  return useMemo(() => {
    const footerColumns = [
      {
        field: 'total',
        visible: true,
        value: <FormattedMessage id="resourceAvailabilityCard.total" />,
        align: 'right',
        fixed: true,
        render: CustomTypography,
        renderClassName: classes.totalLabel,
        overviewUnit
      },
      {
        field: 'totalResources',
        visible: true,
        align: 'left',
        value: totals?.totalResources,
        render: FormattedUnitValue,
        renderClassName: classes.totalLabel,
        overviewUnit
      },
      {
        field: 'workingTime',
        visible: true,
        align: 'left',
        value: totals?.workingTime,
        render: FormattedUnitValue,
        renderClassName: classes.totalLabel,
        overviewUnit
      },
      {
        field: 'fittingAllocation',
        visible: true,
        align: 'left',
        value: totals?.fittingAllocation,
        render: FormattedUnitValue,
        renderClassName: classes.totalLabel,
        overviewUnit
      },
      selectedProblem === PROBLEM_FILTER_OPTIONS.BENCH
        ? {
            field: 'bench',
            visible: true,
            align: 'left',
            value: totals?.bench,
            render: FormattedUnitValue,
            renderClassName: classNames(
              classes.totalLabel,
              classes.benchOverallocationValue
            ),
            overviewUnit
          }
        : {
            field: 'overAllocation',
            visible: true,
            align: 'left',
            value: totals?.overAllocation,
            render: FormattedUnitValue,
            renderClassName: classNames(
              classes.totalLabel,
              classes.benchOverallocationValue
            ),
            overviewUnit
          }
    ];

    return footerColumns.reduce(
      (obj, item) => ({
        ...obj,
        [item.field]: item
      }),
      {}
    );
  }, [classes, totals, selectedProblem, overviewUnit]);
};

export default useListTableFooterColumns;
